// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Camera$LumiDocuments from "./Camera.res.js";
import * as PlaceModel$LumiDocuments from "./PlaceModel.res.js";

let jsonCodec = Jzon.object3(param => [
  param.primaryCameraKey,
  param.primaryCameraPlaceModel,
  param.otherCameras
], param => ({
  TAG: "Ok",
  _0: {
    primaryCameraKey: param[0],
    primaryCameraPlaceModel: param[1],
    otherCameras: param[2]
  }
}), Jzon.field("primaryCameraKey", Document$LumiStore.Key.jsonCodec()), Jzon.field("primaryCameraPlaceModel", PlaceModel$LumiDocuments.jsonCodec), Jzon.field("otherCameras", Camera$LumiDocuments.Schema.$$Map.jsonCodec(PlaceModel$LumiDocuments.jsonCodec)));

let Place = {
  jsonCodec: jsonCodec
};

export {
  Place,
}
/* jsonCodec Not a pure module */
